import {onlyMatchingSource} from '../../utils';
import type {GuidedItemV2} from '../../models/models';
import {GuidedUiFeaturedBanners} from '../../models/Guided.schema';
import type {GuidedQuickLinkDetails} from '../../models/quick-link';
import type {GuidedV2FactoryState} from '../../models/ui';
import {h} from '@stencil/core';
import type {GuidedV2BannerCta} from '../../models/banner';
import {MegaBanner} from '../../../design-system/mega-banner/mega-banner';
import {RegisterType} from '../component-registry';

export class GuidedV2FeaturedCtaBanners {

  @RegisterType(GuidedUiFeaturedBanners.type)
  render<T extends GuidedQuickLinkDetails>(
    inputData: GuidedUiFeaturedBanners,
    state: GuidedV2FactoryState<T>,
  ) {

      const {
        itemSources,
        slots,
      } = inputData; //comes from configuration

      const {
        eventEmitters,
        results, //the API response
      } = state;

      const matchingResults = results
        .filter(onlyMatchingSource(itemSources))
        .slice(0, slots)
        .map((baseItem: GuidedItemV2) => {
            const item = baseItem.details as unknown as GuidedV2BannerCta;
            return {
              text: item.bannerTitle,
              description: item.bannerDescription ?? '',
              buttonText: item.bannerButtonText ?? '',
              href: item.bannerOpenUrl ?? '',
              src: item.bannerImageUrl ?? '',
              target: item.bannerButtonTarget ?? '_self',
            };
        });

      return <div class="guided-v2-section__footer">
        {matchingResults.map(item => {
            return <MegaBanner
              text={item.text}
              description={item.description}
              buttonText={item.buttonText}
              href={item.href}
              src={item.src}
              target={item.target}
              eventEmitters={eventEmitters}
            />;
        })}</div>;
  }

}
